<template>
    <div v-if="pgmAdDto != null">

        <b-form-group
                label="프로모션명"
                label-for="gapPromotionName"
                :label-class="labelClasses"
                invalid-feedback="프로모션 명을 입력해주세요.">
            <b-form-input id="gapPromotionName"
                          required
                          v-model="pgmAdDto.title">
            </b-form-input>
            <p>* 운영과 관리용으로 유저에게 노출되지 않습니다.</p>
        </b-form-group>
        <b-form-group
                label="게임과 타입 선택"
                :label-class="labelClasses">
            <div class="vSelectWrapper">
                <v-select ref="selectApp"
                          v-model="subSelectedApp" label="name" :options="gapPregListInProgressOptions" placeholder="광고 사전예약 이름을 입력해주세요." >
                    <template slot="no-options">검색 결과가 없습니다.</template>
                </v-select>
            </div>
            <!--<b-form-input id="url"-->
                          <!--required-->
                          <!--v-model="pgmAdDto.linkedUrl"-->
                          <!--placeholder="url을 등록해주세요."-->
                          <!--disabled>-->
            <!--</b-form-input>-->
        </b-form-group>
        <b-link :href="getPregUrl + pgmAdDto.linkedUrl" target="_blank"><strong>{{pgmAdDto.linkedUrl}}</strong></b-link>
        <br><br>

        <b-form-group
                label="노출기간"
                :label-class="labelClasses">
            <b-form-group
                    label="시작"
                    label-for="startTime" :horizontal="true" :label-cols="1">
                <date-picker id="startTime" required :value="pgmAdDto.startTime" v-on:input="pgmAdDto.startTime = new Date($event)" @dp-change="onStartChangeDate($event.date, false)" :config="dateOptions"></date-picker>
            </b-form-group>
            <b-form-group
                    label="종료"
                    label-for="endTime" :horizontal="true" :label-cols="1">
                <date-picker id="endTime" required :value="pgmAdDto.endTime" v-on:input="pgmAdDto.endTime = new Date($event)" :config="endDateOptions"></date-picker>
            </b-form-group>
        </b-form-group>
    </div>
</template>
<script>
    import gapPregService from '@/common/api/gap.preg.service'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { MODULE_NAME as PREG_MODULE, FETCH_PREGS_BY_APP_MASTER_ID, FETCH_CODES } from '@/store/preg/actions.type'
    import { MODULE_NAME as APP_MODULE, FETCH_APPS } from '@/store/app/actions.type'
    import { labelClasses, IMAGE_UPLOAD_URL } from '@/constants'
    import { mapState, mapMutations, mapGetters } from 'vuex'
    import { $showModalWithErrorMsg, addProperty, removeProperty, validationURL } from '@/common/util'
    import { SHOW_MODAL } from '@/store/ui/mutations.type'
    import playGameService from '@/common/api/playGame.service'
    export default {
        name: "GapPgmAdInputFormat",
        props: {
            config: Object,
            pgmAdDto: Object,
            pregMasterId: Number,
            selectedApp: Object
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        data () {
            return {
                subSelectedApp: null,
                gapPregList: [],
                pregUrl: process.env.VUE_APP_PREG_URL,

                languages: ['ko'],

                labelClasses: labelClasses,

                dateOptions: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    sideBySide : true,
                },
                endDownloadDateOptions: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    sideBySide : true,
                },
                endDateOptions: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    sideBySide : true,
                }
            }
        },
        mounted () {
            console.log(this.pgmAdDto)

            this.pgmAdDto.linkedSvcType = 'preregistration'

            this.$store.dispatch(PREG_MODULE + FETCH_CODES)
                .catch($showModalWithErrorMsg.bind(this))

            gapPregService.getFinishedPregList()
                .then(({data}) => {
                    console.log('response')
                    console.log(data)

                    if (data.status === 200) {
                        // this.gapPregList = this.getPregListWithoutFrontInfo(data.data)
                        this.gapPregList = data.data;
                        if (this.subSelectedApp != null && this.subSelectedApp.value != null) {
                            this.gapPregChangeHandling(this.subSelectedApp.value)
                        }
                    } else {
                        alert('광고 사전예약 조회에 실패했습니다.')
                    }
                })
        },
        methods: {
            getPregListWithoutFrontInfo(pregListForFront) {
                let result = []

                pregListForFront.forEach(element=> {
                    result.push({
                        marketInfoDtoList: element.preg.marketInfo,
                        pregMaster: element.preg.pregMaster
                    })
                })

                return result
            },
            gapPregChangeHandling (pregId) {
                console.log('found')
                const found = this.gapPregList.find((element) => {
                    return element.pregMaster.id === pregId
                })
                console.log(found)
                if (found !== undefined) {
                    this.selectedPreg = found
                    this.pgmAdDto.linkedUrl = found.pregMaster.permaUri
                    this.pgmAdDto.appMasterId = found.pregMaster.appInfo.appMasterId
                    this.pgmAdDto.pregMasterId = found.pregMaster.id
                    this.pgmAdDto.linkedSvcType = 'preregistration'
                    this.pgmAdDto.appName = found.pregMaster.appInfo.appName
                }
            },
            onStartChangeDate (date, isDownload) {
                if (!date) {
                    return
                }
                date = new Date(date)
                if (isDownload) {
                    this.$set(this.endDownloadDateOptions, 'minDate', date)
                } else {
                    this.$set(this.endDateOptions, 'minDate', date)
                }
            },
            ...mapMutations('ui', [SHOW_MODAL])
        },
        computed: {
            getPregUrl() {
                return this.pregUrl && this.pgmAdDto.pregMasterId >= 1000 ? this.pregUrl.substr(0, this.pregUrl.length - 3) + 'ar/' : this.pregUrl
            },
            gapPregListInProgressOptions() {
                let options = []

                this.gapPregList.forEach((element) => {
                  if (element.pregMaster.type !== 'gameNews') {
                    let name = element.pregMaster.appInfo.appName + ' :: ' + element.pregMaster.name
                    options.push({name: name, value: element.pregMaster.id})
                  }
                })

                return options
            },
        },
        watch: {
            subSelectedApp (val) {
              console.log('watch subSelectedApp')
                console.log(val)
                if(val == null) {
                    // 초기화 부분
                    this.pgmAdDto.appMasterId = 0
                    this.pgmAdDto.pregMasterId = 0
                    this.pgmAdDto.linkedSvcType = ''
                    this.pgmAdDto.linkedUrl = ''
                    return
                }
                this.gapPregChangeHandling(val.value)
            },
            selectedApp(val) {
                console.log('selectedApp')
                console.log(val)
                this.subSelectedApp = this.selectedApp
            }
        }
    }
</script>
<style>
    .vSelectWrapper {
        display: inline-block;
        width: 350px;
    }
    .vSelectWrapper .dropdown-toggle:after {
        display: none !important;
    }
</style>
